module.exports = __webpack_public_path__ + "img/dica-importacao-vacinados.0b34e340.svg";